import { ManyToManyFieldPrefix } from './constants';
var getReferenceManyToManyFormField = function (_a) {
    var resource = _a.resource, through = _a.through, reference = _a.reference;
    return "".concat(ManyToManyFieldPrefix).concat(resource, "/").concat(through, "/").concat(reference);
};
export default getReferenceManyToManyFormField;
